import controller from './admin-datagrid.controller.js';

let adminDatagridModule = angular.module('admin-datagrid', [])

    .directive('adminDatagrid', () => {
        'ngInject';

        return {
            retrict: 'EA',
            controller: controller,
            controllerAs: '$ctrl',
            scope: {
                srcData: '@',
                itemsPerPage: '@',
                filterSelectProperty: '@'
            },
            bindToController: true,
            transclude: true,
            link: (scope, element, attrs, ctrlr, transclude) => {
                transclude(scope, (clone, scope) => {
                    element.append(clone);
                });
            }
        };
    })

    .name;

export default adminDatagridModule;



// WEBPACK FOOTER //
// ./src/app/angular/admin-datagrid/admin-datagrid.js